import { Instance, SnapshotOut, types } from 'mobx-state-tree';

/**
 * # OauthToken
 *
 * OauthToken을 설명하세요.
 */
export const OauthToken = types
  .model('OauthToken')
  // --------------------------------------------------------------------------
  .props({
    token_type: types.string,
    access_token: types.string,
    expires_in: types.number,
    refresh_token: types.string,
    refresh_expires_in: types.number,
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model oauthToken --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: Partial<IOauthTokenSnapshot>) => {
      const newProps = { ...self, ...props } as IOauthToken;
      (Object.keys(newProps) as TOauthTokenKeys[]).forEach((key) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TOauthToken = Instance<typeof OauthToken>;
type TOauthTokenSnapshot = SnapshotOut<typeof OauthToken>;

export interface IOauthToken extends TOauthToken {}
export type TOauthTokenKeys = keyof TOauthTokenSnapshot & string;
export interface IOauthTokenSnapshot extends TOauthTokenSnapshot {}
export const createOauthToken = () => types.optional(OauthToken, {} as TOauthToken);
